import Header from "components/layout/Header";
import BookingForm from "./sections/BookingForm";
import Banner from "./sections/Banner";
import BackgroundImage from "./sections/bgImage/BackgroundImage";
import {useEffect, useState} from "react";
import Footer from "components/layout/Footer";
import { StorageUtils } from "utils/storageUtils";
import { ProviderUtils } from "utils/providerUtils";
import history from "history/browser";
import { closeWebview } from "utils/lottecardUtils";
import { useAppDispatch } from "app/hooks";
import { deleteMyOrders, resetFilterSetting } from "app/myOrdersSlice";
import LachaRewardBanner from "./sections/LachaRewardBanner";
import CardLayout from "components/layout/CardLayout";
import { useNavigate } from "react-router-dom";
import AttractionsIcon from "@mui/icons-material/Attractions";
import { __STAGING__ } from "const/properties";
import useModalSheet from "../../../hooks/overlay/useModalSheet";
import AuthService from "../../../services/authService";
import useReduxUtils from "../../../hooks/useReduxUtils";

const HomePage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const { resetStore } = useReduxUtils({ retainToken: true });

  const [NoticeModal] = useModalSheet({
    defaultVisible: sessionStorage.getItem("NoticeModalRead") !== "true",
    callbackOk: () => {
      sessionStorage.setItem("NoticeModalRead", "true");
    },
  });

  // // 코레일 작업 완료 일정
  const maintenanceEndTime = new Date(2025, 5, 14, 0, 0);
  const isMaintenanceDone = new Date() > maintenanceEndTime;

  useEffect(() => {
    const checkLoggedIn = async () => {
      if (!isChecking) {
        return;
      }
      const response = await AuthService.isLoggedIn();
      setIsLoggedIn(response);
      setIsChecking(false);
    };
    checkLoggedIn();

    dispatch(deleteMyOrders());
    dispatch(resetFilterSetting());

    StorageUtils.TrainTab.remove();
    StorageUtils.ScrollY.remove();
  }, [dispatch]);

  if (!isChecking && !isLoggedIn) {
    console.log("로그아웃 상태입니다!");
    resetStore();
  }

  useEffect(() => {
    // navigate(window.location.pathname); 이 코드 있으면 안 됨 - url 복붙 하면 / 로 이동함

    const listenBackEvent = () => {
      if (ProviderUtils.isHanpass) {
        StorageUtils.HanpassBack.remove();
        window.location.href = "http://finish";
      }
      if (ProviderUtils.isLottecard) {
        closeWebview();
      }
    };

    const historyEvent = history.listen(({ action }) => {
      if (action === "POP") {
        listenBackEvent();
      }
    });

    return () => {
      historyEvent();
      // window.history.replaceState(null, "");
    };
  }, []);

  return (
    <>
      <Header />
      <BackgroundImage />

      <section className="relative mx-auto mb-20 min-h-[80vh] max-w-md space-y-4 px-4">
        <BookingForm />

        {__STAGING__ && (
          <CardLayout>
            <div
              className="flex items-center justify-center gap-2"
              onClick={() => {
                navigate("/activity");
              }}
            >
              <AttractionsIcon color="primary" className="!text-5xl" />
              <p className="text-xl font-bold text-text-secondary">
                일본 여행 상품 예약하기
              </p>
            </div>
          </CardLayout>
        )}

        <LachaRewardBanner />

        {ProviderUtils.provider?.provider !== "lottecard" && <Banner />}
      </section>

      {!isMaintenanceDone && (
        <NoticeModal modal>
          <div className="space-y-4">
            <p className="font-bold">
              [공지] 코레일 열차운행 중지 및 지연 알림
            </p>
            <p className="break-normal text-start">
              가좌 ~ 신촌간 선로에 이삿짐 사다리차가 넘어져 열차운행 선로 지장 복구를 위해
              서울역, 용산역 출발 및 도착 열차가 일부 운행 중지 및 지연되고있습니다.
              <br />
              <br />
              열차운행 상황을 코레일톡, 홈페이지 등에서 확인해주시기 바라며,
              바쁘신 고객님은 타 교통수단을 이용해주시기 바랍니다.
            </p>
          </div>
        </NoticeModal>
      )}

      <Footer />
    </>
  );
};

export default HomePage;
